export const reviewRequestConfigView = {
  options: {
    emailTemplate: 'emailTemplate',
    sms: 'sms',
    printer: 'printer',
    coupon: 'coupon',
    thankYouPage: 'thankYouPage',
    timing: 'timing',
  },
};
export const service = {
  ebaySeller: 'Ebay Seller Feedback',
  // amazonSeller: 'Amazon Seller Feedback',
  // amazon: 'Amazon',
  aliexpress: 'Aliexpress',
  ebay: 'Ebay',
  notImported: 'Not Imported',
};
export const templateTypes = {
  //same as in assets.py
  reviewRequest: 'reviewRequest',
  coupon: 'coupon',
  verifyEmail: 'verifyEmail',
  smsReviewRequest: 'reviewRequestSms',
  orderPrinter: 'orderPrinter',
  thankYouPage: 'thankYouForReview',
  photoRequest: 'photoRequest',
};
export const advancedTemplateTypes = {
  reviewRequest: 'reviewRequestEmail',
  coupon: 'couponEmail',
  verifyEmail: 'unverifiedReviewConfirmationEmail',
  photoRequest: 'photoRequestEmail',
};
export const widgets = {
  productReviewWidget: 'productReviewWidget',
  stars: 'stars',
  allReviewsPage: 'allReviewsPage',
  carousel: 'carousel',
  footerEmailBadge: 'footerEmailBadge',
  opinewReviewsTab: 'opinewReviewsTab',
};
export const icons = {
  couponPercent: `M14.8 8L16 9.2L9.2 16L8 14.8L14.8 8M4 4H20C21.11 4 22 4.89 22 6V10C20.9 10 20 10.9 20
          12C20 13.11 20.9 14 22 14V18C22 19.11 21.11 20 20 20H4C2.9 20 2 19.11 2 18V14C3.11 14 4
          13.11 4 12C4 10.9 3.11 10 2 10V6C2 4.89 2.9 4 4 4M4 6V8.54C5.24 9.26 6 10.57 6 12C6 13.43
          5.24 14.75 4 15.46V18H20V15.46C18.76 14.75 18 13.43 18 12C18 10.57 18.76 9.26 20
          8.54V6H4M9.5 8C10.33 8 11 8.67 11 9.5C11 10.33 10.33 11 9.5 11C8.67 11 8 10.33 8 9.5C8
          8.67 8.67 8 9.5 8M14.5 13C15.33 13 16 13.67 16 14.5C16 15.33 15.33 16 14.5 16C13.67 16 13
          15.33 13 14.5C13 13.67 13.67 13 14.5 13Z`,
  printer: `M19 8C20.66 8 22 9.34 22 11V17H18V21H6V17H2V11C2 9.34 3.34 8 5 8H6V3H18V8H19M8
          5V8H16V5H8M16 19V15H8V19H16M18 15H20V11C20 10.45 19.55 10 19 10H5C4.45 10 4 10.45 4
          11V15H6V13H18V15M19 11.5C19 12.05 18.55 12.5 18 12.5C17.45 12.5 17 12.05 17 11.5C17 10.95
          17.45 10.5 18 10.5C18.55 10.5 19 10.95 19 11.5Z`,
  pageLayoutHeaderFooter: `M18 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11
                              20 20V4C20 2.9 19.11 2 18 2M18 20H6V16H18V20M18 8H6V4H18V8Z`,
  cog: `M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0
            10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M10,22C9.75,22 9.54,21.82
            9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95
            4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78
            2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95
            2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32
            9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18
            14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05
            19.66,5.27L21.66,8.73C21.79,8.95 21.73,9.22
            21.54,9.37L19.43,11L19.5,12L19.43,13L21.54,14.63C21.73,14.78 21.79,15.05
            21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.04 19.05,18.95L16.56,17.95C16.04,18.34
            15.5,18.68 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22
            14,22H10M11.25,4L10.88,6.61C9.68,6.86 8.62,7.5
            7.85,8.39L5.44,7.35L4.69,8.65L6.8,10.2C6.4,11.37 6.4,12.64
            6.8,13.8L4.68,15.36L5.43,16.66L7.86,15.62C8.63,16.5 9.68,17.14
            10.87,17.38L11.24,20H12.76L13.13,17.39C14.32,17.14 15.37,16.5
            16.14,15.62L18.57,16.66L19.32,15.36L17.2,13.81C17.6,12.64 17.6,11.37
            17.2,10.2L19.31,8.65L18.56,7.35L16.15,8.39C15.38,7.5 14.32,6.86
            13.12,6.62L12.75,4H11.25Z`,
};

export const permissions = {
  permissionCouponLimitTier1: 'coupon_tier_1',
  permissionCouponLimitTier2: 'coupon_tier_2',
  permissionCouponLimitTier3: 'coupon_tier_3',
  permissionCouponLimitTier4: 'coupon_tier_4',
};
export const PLAN_CONSTANTS = {
  highlightFeatureLength: [7, 5, 5, 6, 4],
};

export const PLAN_FEATURE_NUMBER_DICT = {
  Enterprise: 7,
  Advanced: 5,
  Growth: 5,
  Starter: 6,
  Free: 4,
  'Extra Trial': 0,
  'Exclusive Starter': 0,
};

export const couponPermissionMapping = {
  coupon_tier_1: 300,
  coupon_tier_2: 2000,
  coupon_tier_3: 7000,
  coupon_tier_4: 30000,
};
export const couponStatus = {
  creating: 'creating',
  created: 'created',
  deleting: 'deleting',
};
export const countries = [
  { value: 'AF', text: 'Afghanistan' },
  { value: 'AX', text: 'Åland Islands' },
  { value: 'AL', text: 'Albania' },
  { value: 'DZ', text: 'Algeria' },
  { value: 'AS', text: 'American Samoa' },
  { value: 'AD', text: 'Andorra' },
  { value: 'AO', text: 'Angola' },
  { value: 'AI', text: 'Anguilla' },
  { value: 'AQ', text: 'Antarctica' },
  { value: 'AG', text: 'Antigua and Barbuda' },
  { value: 'AR', text: 'Argentina' },
  { value: 'AM', text: 'Armenia' },
  { value: 'AW', text: 'Aruba' },
  { value: 'AU', text: 'Australia' },
  { value: 'AT', text: 'Austria' },
  { value: 'AZ', text: 'Azerbaijan' },
  { value: 'BS', text: 'Bahamas' },
  { value: 'BH', text: 'Bahrain' },
  { value: 'BD', text: 'Bangladesh' },
  { value: 'BB', text: 'Barbados' },
  { value: 'BY', text: 'Belarus' },
  { value: 'BE', text: 'Belgium' },
  { value: 'BZ', text: 'Belize' },
  { value: 'BJ', text: 'Benin' },
  { value: 'BM', text: 'Bermuda' },
  { value: 'BT', text: 'Bhutan' },
  { value: 'BO', text: 'Bolivia, Plurinational State of' },
  { value: 'BQ', text: 'Bonaire, Sint Eustatius and Saba' },
  { value: 'BA', text: 'Bosnia and Herzegovina' },
  { value: 'BW', text: 'Botswana' },
  { value: 'BV', text: 'Bouvet Island' },
  { value: 'BR', text: 'Brazil' },
  { value: 'IO', text: 'British Indian Ocean Territory' },
  { value: 'BN', text: 'Brunei Darussalam' },
  { value: 'BG', text: 'Bulgaria' },
  { value: 'BF', text: 'Burkina Faso' },
  { value: 'BI', text: 'Burundi' },
  { value: 'KH', text: 'Cambodia' },
  { value: 'CM', text: 'Cameroon' },
  { value: 'CA', text: 'Canada' },
  { value: 'CV', text: 'Cape Verde' },
  { value: 'KY', text: 'Cayman Islands' },
  { value: 'CF', text: 'Central African Republic' },
  { value: 'TD', text: 'Chad' },
  { value: 'CL', text: 'Chile' },
  { value: 'CN', text: 'China' },
  { value: 'CX', text: 'Christmas Island' },
  { value: 'CC', text: 'Cocos (Keeling) Islands' },
  { value: 'CO', text: 'Colombia' },
  { value: 'KM', text: 'Comoros' },
  { value: 'CG', text: 'Congo' },
  { value: 'CD', text: 'Congo, the Democratic Republic of the' },
  { value: 'CK', text: 'Cook Islands' },
  { value: 'CR', text: 'Costa Rica' },
  { value: 'CI', text: 'Côte dIvoire' },
  { value: 'HR', text: 'Croatia' },
  { value: 'CU', text: 'Cuba' },
  { value: 'CW', text: 'Curaçao' },
  { value: 'CY', text: 'Cyprus' },
  { value: 'CZ', text: 'Czech Republic' },
  { value: 'DK', text: 'Denmark' },
  { value: 'DJ', text: 'Djibouti' },
  { value: 'DM', text: 'Dominica' },
  { value: 'DO', text: 'Dominican Republic' },
  { value: 'EC', text: 'Ecuador' },
  { value: 'EG', text: 'Egypt' },
  { value: 'SV', text: 'El Salvador' },
  { value: 'GQ', text: 'Equatorial Guinea' },
  { value: 'ER', text: 'Eritrea' },
  { value: 'EE', text: 'Estonia' },
  { value: 'ET', text: 'Ethiopia' },
  { value: 'FK', text: 'Falkland Islands (Malvinas)' },
  { value: 'FO', text: 'Faroe Islands' },
  { value: 'FJ', text: 'Fiji' },
  { value: 'FI', text: 'Finland' },
  { value: 'FR', text: 'France' },
  { value: 'GF', text: 'French Guiana' },
  { value: 'PF', text: 'French Polynesia' },
  { value: 'TF', text: 'French Southern Territories' },
  { value: 'GA', text: 'Gabon' },
  { value: 'GM', text: 'Gambia' },
  { value: 'GE', text: 'Georgia' },
  { value: 'DE', text: 'Germany' },
  { value: 'GH', text: 'Ghana' },
  { value: 'GI', text: 'Gibraltar' },
  { value: 'GR', text: 'Greece' },
  { value: 'GL', text: 'Greenland' },
  { value: 'GD', text: 'Grenada' },
  { value: 'GP', text: 'Guadeloupe' },
  { value: 'GU', text: 'Guam' },
  { value: 'GT', text: 'Guatemala' },
  { value: 'GG', text: 'Guernsey' },
  { value: 'GN', text: 'Guinea' },
  { value: 'GW', text: 'Guinea-Bissau' },
  { value: 'GY', text: 'Guyana' },
  { value: 'HT', text: 'Haiti' },
  { value: 'HM', text: 'Heard Island and McDonald Islands' },
  { value: 'VA', text: 'Holy See (Vatican City State)' },
  { value: 'HN', text: 'Honduras' },
  { value: 'HK', text: 'Hong Kong' },
  { value: 'HU', text: 'Hungary' },
  { value: 'IS', text: 'Iceland' },
  { value: 'IN', text: 'India' },
  { value: 'ID', text: 'Indonesia' },
  { value: 'IR', text: 'Iran, Islamic Republic of' },
  { value: 'IQ', text: 'Iraq' },
  { value: 'IE', text: 'Ireland' },
  { value: 'IM', text: 'Isle of Man' },
  { value: 'IL', text: 'Israel' },
  { value: 'IT', text: 'Italy' },
  { value: 'JM', text: 'Jamaica' },
  { value: 'JP', text: 'Japan' },
  { value: 'JE', text: 'Jersey' },
  { value: 'JO', text: 'Jordan' },
  { value: 'KZ', text: 'Kazakhstan' },
  { value: 'KE', text: 'Kenya' },
  { value: 'KI', text: 'Kiribati' },
  { value: 'KP', text: 'Korea, Democratic Peoples Republic of' },
  { value: 'KR', text: 'Korea, Republic of' },
  { value: 'KW', text: 'Kuwait' },
  { value: 'KG', text: 'Kyrgyzstan' },
  { value: 'LA', text: 'Lao Peoples Democratic Republic' },
  { value: 'LV', text: 'Latvia' },
  { value: 'LB', text: 'Lebanon' },
  { value: 'LS', text: 'Lesotho' },
  { value: 'LR', text: 'Liberia' },
  { value: 'LY', text: 'Libya' },
  { value: 'LI', text: 'Liechtenstein' },
  { value: 'LT', text: 'Lithuania' },
  { value: 'LU', text: 'Luxembourg' },
  { value: 'MO', text: 'Macao' },
  { value: 'MK', text: 'Macedonia, the Former Yugoslav Republic of' },
  { value: 'MG', text: 'Madagascar' },
  { value: 'MW', text: 'Malawi' },
  { value: 'MY', text: 'Malaysia' },
  { value: 'MV', text: 'Maldives' },
  { value: 'ML', text: 'Mali' },
  { value: 'MT', text: 'Malta' },
  { value: 'MH', text: 'Marshall Islands' },
  { value: 'MQ', text: 'Martinique' },
  { value: 'MR', text: 'Mauritania' },
  { value: 'MU', text: 'Mauritius' },
  { value: 'YT', text: 'Mayotte' },
  { value: 'MX', text: 'Mexico' },
  { value: 'FM', text: 'Micronesia, Federated States of' },
  { value: 'MD', text: 'Moldova, Republic of' },
  { value: 'MC', text: 'Monaco' },
  { value: 'MN', text: 'Mongolia' },
  { value: 'ME', text: 'Montenegro' },
  { value: 'MS', text: 'Montserrat' },
  { value: 'MA', text: 'Morocco' },
  { value: 'MZ', text: 'Mozambique' },
  { value: 'MM', text: 'Myanmar' },
  { value: 'NA', text: 'Namibia' },
  { value: 'NR', text: 'Nauru' },
  { value: 'NP', text: 'Nepal' },
  { value: 'NL', text: 'Netherlands' },
  { value: 'NC', text: 'New Caledonia' },
  { value: 'NZ', text: 'New Zealand' },
  { value: 'NI', text: 'Nicaragua' },
  { value: 'NE', text: 'Niger' },
  { value: 'NG', text: 'Nigeria' },
  { value: 'NU', text: 'Niue' },
  { value: 'NF', text: 'Norfolk Island' },
  { value: 'MP', text: 'Northern Mariana Islands' },
  { value: 'NO', text: 'Norway' },
  { value: 'OM', text: 'Oman' },
  { value: 'PK', text: 'Pakistan' },
  { value: 'PW', text: 'Palau' },
  { value: 'PS', text: 'Palestine, State of' },
  { value: 'PA', text: 'Panama' },
  { value: 'PG', text: 'Papua New Guinea' },
  { value: 'PY', text: 'Paraguay' },
  { value: 'PE', text: 'Peru' },
  { value: 'PH', text: 'Philippines' },
  { value: 'PN', text: 'Pitcairn' },
  { value: 'PL', text: 'Poland' },
  { value: 'PT', text: 'Portugal' },
  { value: 'PR', text: 'Puerto Rico' },
  { value: 'QA', text: 'Qatar' },
  { value: 'RE', text: 'Réunion' },
  { value: 'RO', text: 'Romania' },
  { value: 'RU', text: 'Russian Federation' },
  { value: 'RW', text: 'Rwanda' },
  { value: 'BL', text: 'Saint Barthélemy' },
  { value: 'SH', text: 'Saint Helena, Ascension and Tristan da Cunha' },
  { value: 'KN', text: 'Saint Kitts and Nevis' },
  { value: 'LC', text: 'Saint Lucia' },
  { value: 'MF', text: 'Saint Martin (French part)' },
  { value: 'PM', text: 'Saint Pierre and Miquelon' },
  { value: 'VC', text: 'Saint Vincent and the Grenadines' },
  { value: 'WS', text: 'Samoa' },
  { value: 'SM', text: 'San Marino' },
  { value: 'ST', text: 'Sao Tome and Principe' },
  { value: 'SA', text: 'Saudi Arabia' },
  { value: 'SN', text: 'Senegal' },
  { value: 'RS', text: 'Serbia' },
  { value: 'SC', text: 'Seychelles' },
  { value: 'SL', text: 'Sierra Leone' },
  { value: 'SG', text: 'Singapore' },
  { value: 'SX', text: 'Sint Maarten (Dutch part)' },
  { value: 'SK', text: 'Slovakia' },
  { value: 'SI', text: 'Slovenia' },
  { value: 'SB', text: 'Solomon Islands' },
  { value: 'SO', text: 'Somalia' },
  { value: 'ZA', text: 'South Africa' },
  { value: 'GS', text: 'South Georgia and the South Sandwich Islands' },
  { value: 'SS', text: 'South Sudan' },
  { value: 'ES', text: 'Spain' },
  { value: 'LK', text: 'Sri Lanka' },
  { value: 'SD', text: 'Sudan' },
  { value: 'SR', text: 'Suriname' },
  { value: 'SJ', text: 'Svalbard and Jan Mayen' },
  { value: 'SZ', text: 'Swaziland' },
  { value: 'SE', text: 'Sweden' },
  { value: 'CH', text: 'Switzerland' },
  { value: 'SY', text: 'Syrian Arab Republic' },
  { value: 'TW', text: 'Taiwan, Province of China' },
  { value: 'TJ', text: 'Tajikistan' },
  { value: 'TZ', text: 'Tanzania, United Republic of' },
  { value: 'TH', text: 'Thailand' },
  { value: 'TL', text: 'Timor-Leste' },
  { value: 'TG', text: 'Togo' },
  { value: 'TK', text: 'Tokelau' },
  { value: 'TO', text: 'Tonga' },
  { value: 'TT', text: 'Trinidad and Tobago' },
  { value: 'TN', text: 'Tunisia' },
  { value: 'TR', text: 'Turkey' },
  { value: 'TM', text: 'Turkmenistan' },
  { value: 'TC', text: 'Turks and Caicos Islands' },
  { value: 'TV', text: 'Tuvalu' },
  { value: 'UG', text: 'Uganda' },
  { value: 'UA', text: 'Ukraine' },
  { value: 'AE', text: 'United Arab Emirates' },
  { value: 'GB', text: 'United Kingdom' },
  { value: 'US', text: 'United States' },
  { value: 'UM', text: 'United States Minor Outlying Islands' },
  { value: 'UY', text: 'Uruguay' },
  { value: 'UZ', text: 'Uzbekistan' },
  { value: 'VU', text: 'Vanuatu' },
  { value: 'VE', text: 'Venezuela, Bolivarian Republic of' },
  { value: 'VN', text: 'Viet Nam' },
  { value: 'VG', text: 'Virgin Islands, British' },
  { value: 'VI', text: 'Virgin Islands, U.S.' },
  { value: 'WF', text: 'Wallis and Futuna' },
  { value: 'EH', text: 'Western Sahara' },
  { value: 'YE', text: 'Yemen' },
  { value: 'ZM', text: 'Zambia' },
  { value: 'ZW', text: 'Zimbabwe' },
];

export const INTEGRATION_CONSTS = {
  HOTJAR_ID: '991658',
  HOTJAR_SNIPPET_VERSION: 6,
  GA_PRODUCTION: 'UA-59714844-4',
  GA_DEVELOPMENT: 'UA-59714844-2',
  FACEBOOK_APP_ID: '905548200004251',
  FACEBOOK_APP_ID_TEST: '4114979921897153',
  extensionId: 'dpnhhplcgccminaooanpkgflaekfndmi',
  UNLAYER_PROJECT_ID: 2197,
};

export const CONFIG_CONSTS = {
  EN: 'en',
  ES: 'es',
  FR: 'fr',
  PT: 'pt',
  ESPANOL: 'Español',
  ENGLISH: 'English',
  FRANCAIS: 'Francais',
  PORTUGUESE: 'Português',
  debounce: 500,
  defaultTrialDays: 14,
  widgetTopSectionStyleDefault: 'default',
  widgetTopSectionStyleCondensed: 'condensed',
  widgetTopSectionStyleClean: 'clean',
  widgetTopSectionStyleModern: 'modern',
  widgetTopSectionStyleCarousel: 'carousel',
  widgetTopSectionStyleMinimal: 'minimal',
  starsAlignmentLeft: 'left',
  starsAlignmentCenter: 'center',
  starsAlignmentRight: 'right',
  permissionCouponLimitTier1Value: 300,
  permissionCouponLimitTier2Value: 2000,
  permissionCouponLimitTier3Value: 7000,
  permissionCouponLimitTier4Value: 30000,
  smartReviews: 'smart_reviews',

  installed: 'installed',
  installing: 'installing',
  uninstalling: 'uninstalling',
  not_installed: 'not_installed',
};

export const CONSTS = {
  ...INTEGRATION_CONSTS,
  ...CONFIG_CONSTS,
  reviewRequestConfigView,
  service,
  templateTypes,
  advancedTemplateTypes,
  widgets,
  icons,

  permissions,
  PLAN_CONSTANTS,
  couponPermissionMapping,
  couponStatus,
  countries,
};

export const Routes = {
  auth: '/auth',
  overview: '/overview',
  generalSettings: '/general-settings',
  importReviews: '/import-reviews',
  reviews: '/reviews',
  seo: '/seo',
  analytics: '/analytics',
  reviewId: '/reviews/:product_id(\\d+)?',
  importReviewsId: '/import-reviews/:product_id?',
  requestSchedule: '/review-schedule',
  printedReviewRequests: '/printed-review-requests',
  migrateReviews: '/migrate-reviews',
  questions: '/questions',
  questionId: '/questions/:product_id?',
  products: '/products/:product_id?',
  email: '/email',
  customizePlugin: '/customize-plugin',
  customizeProduct: '/customize-product',
  customizePluginNew: '/customize-plugin-new',
  customizeCarousel: '/customize-carousel',
  customizeFacebook: '/customize-facebook',
  customizeFloatingWidget: '/customize-floating-widget',
  settings: '/settings',
  account: '/plans-billings',
  integration: '/integration',
  integrationFilter: '/filter',
  integrationOld: '/integrationOld',
  customReviewForm: '/custom-review-form',
  widgets: '/widgets',
  advancedWidgets: '/widgets-advanced-installation',
  customizeBadge: '/customize-badge',
  allReviewsPage: '/all-reviews',
  reviewRequestEmail: '/review-request-email',
  countryReviewRequestEmail: '/review-request-email/:country_code?',
  couponEmail: '/coupon-email',
  countryCouponEmail: '/coupon-email/:country_code?',
  unverifiedReviewConfirmationEmail: '/unverified-review-confirmation-email',
  countryUnverifiedReviewConfirmationEmail: '/unverified-review-confirmation-email/:country_code?',
  requestViaLink: '/request-via-link',
  photoRequestEmail: '/photo-request-email',
  countryPhotoRequestEmail: '/photo-request-email/:country_code?',
  unverifiedReviewSimpleEmail: '/unverified-review-simple-email',
  thankYouPageTemplate: '/thank-you-page-template',
  countryThankYouPageTemplate: '/thank-you-page-template/:country_code?',
  reviewRequestSMS: '/review-request-sms',
  templatesSMS: '/sms-templates',
  settingsCustomCss: '/settings-custom-css',
  reviewRequestsSettings: '/review-requests-settings',
  reviewRequestsConfiguration: '/review-requests-configuration',
  allReviewsWidgetSettings: '/all-reviews-widget-settings',
  linkShops: '/link-shops',
  linkProducts: '/link-products',
  helpAndTutorials: '/help-and-tutorials',
  reviewImporterSettings: '/settings-review-importer',
  shopReviews: '/shop-reviews',
  pickTrialPlan: '/pick-trial-plan',
  trialEnded: '/trial-ended',
  welcome: '/welcome/:step?',
  orderPrinter: '/order-printer',
  customizeStars: '/customize-stars',
  customizeRequests: '/customize-requests',
  customizeStarsNew: '/customize-stars-new',
  groupEdit: '/group-edit/:groupId?',
  group: '/add-group',
  smartReviews: '/smart-reviews',
  getStarted: '/get-started',
  teamMembers: '/my-users',
  referral: '/referral',
  firstSteps: '/first-steps',
  planPick: '/plan-pick',
  googleShoppingIntegration: '/google-shopping-integration',
  aftershipIntegration: '/aftership-integration',
  orderPrinterIntegration: '/order-printer-integration',
  orderPrinterProIntegration: '/order-printer-pro-integration',
  klaviyoIntegration: '/klaviyo-integration',
  shopifyFlow: '/shopify-flow',
  pageflyIntegration: '/pagefly-integration',
  gorgiasIntegration: '/gorgias-integration',
  zendeskIntegration: '/zendesk-integration',
  attentiveIntegration: '/attentive-integration',
  omnisendIntegration: '/omnisend-integration',
  riseAiIntegration: '/rise-ai-integration',
  smileIoIntegration: '/smile-io-integration',
  loyaltyLionIntegration: '/loyalty-lion-integration',
  salesforceIntegration: '/salesforce-integration',
  layouthubIntegration: '/layouthub-integration',
  weglotIntegration: '/weglot-integration',
  fastSimonIntegration: '/fast-simon-integration',
  wiserIntegration: '/wiser-integration',
  limespotIntegration: '/limespot-integration',
  gempagesIntegration: '/gempages-integration',
  carsonIntegration: '/carson-integration',
  jsonLdForSeoIntegration: '/json-ld-for-seo-integration',
  seoBoosterIntegration: '/seo-booster-integration',
  rebuyIntegration: '/rebuy-integration',
  seoAllInOneIntegration: '/seo-all-in-one-integration',
  installWizard: '/install-wizard',
  requestEmailTemplate: '/request-email-template',
  couponEmailTemplate: '/coupon-email-template',
  photoEmailTemplate: '/photo-email-template',
  thankYouEmailTemplate: '/thank-you-email-template',
  requestWizard: '/request-wizard',
  OberloIntegration: '/oberlo-integration',
  DropifiedIntegration: '/dropified-integration',
  ImportifyIntegration: '/importify-integration',
  SpreadrIntegration: '/spreadr-integration',
  YoastIntegration: '/yoast-integration',
  SeoImageIntegration: '/seo-image-integration',
  // bazaarvoiceIntegration: '/bazaarvoice-integration',
  ZipifyIntegration: '/zipify-integration',
  SchemaIntegration: '/schema-breadcrumbs-integration',
  DsersIntegration: '/dsers-integration',
  SeoImageCompression: '/seo-image-compression-integration',
  Agencies: '/agencies',
  HeyCarson: '/agencies/hey-carson',
  PollardMedia: '/agencies/pollard-media',
  BrandActive: '/agencies/brand-active',
  BoldStrategies: '/agencies/bold-strategies',
  FourSocial: '/agencies/four-social',
  HawkeMedia: '/agencies/hawke-media',
  AttentionGrabbing: '/agencies/attention-grabbing',
  Droomtech: '/agencies/droomtech',
  RaysTechnology: '/agencies/rays-technology',
  ArrowIntegration: '/agencies/arrow-integration',
  BlueOwl: '/agencies/blue-owl',
  Digitlabs: '/agencies/digitlabs',
  AutoQA: '/auto-q-a',
};

export const emailTemplates = {
  htmlBase:
    '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" ><head><!--[if gte mso 9 ]><xml><o:OfficeDocumentSettings><o:AllowPNG /><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml ><! [endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8" /><meta name="viewport" content="width=device-width, initial-scale=1.0" /><meta name="x-apple-disable-message-reformatting" /><!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge" /><!--<![endif]--><title></title><style type="text/css"> table, td { color: #000000; } a { color: #0000ee; text-decoration: underline; } @media only screen and (min-width: 620px) { .u-row { width: 600px !important; } .u-row .u-col { vertical-align: top; } .u-row .u-col-100 { width: 600px !important; } } @media (max-width: 620px) { .u-row-container { max-width: 100% !important; padding-left: 0px !important; padding-right: 0px !important; } .u-row .u-col { min-width: 320px !important; max-width: 100% !important; display: block !important; } .u-row { width: calc(100% - 40px) !important; } .u-col { width: 100% !important; } .u-col > div { margin: 0 auto; } } body { margin: 0; padding: 0; } table, tr, td { vertical-align: top; border-collapse: collapse; } p { margin: 0; } .ie-container table, .mso-container table { table-layout: fixed; } * { line-height: inherit; } a[x-apple-data-detectors="true"] { color: inherit !important; text-decoration: none !important; } .multiple-button-mobile { display:none; } .multiple-button { display:table-row; } @media only screen and (max-width: 480px) { .multiple-button { display:none; } .multiple-button-mobile { display:table-row; } } img {width: auto !important; max-width: 100% !important;  max-height: 400px !important;}</style></head><body class="clean-body" style=" margin: 0; padding: 0; -webkit-text-size-adjust: 100%; background-color: {background_color}; color: #000000; " ><!--[if IE]><div class="ie-container"><![endif]--><!--[if mso]><div class="mso-container"><![endif]--><table style=" border-collapse: collapse; table-layout: fixed; border-spacing: 0; mso-table-lspace: 0pt; mso-table-rspace: 0pt; vertical-align: top; min-width: 320px; margin: 0 auto; background-color: {background_color}; width: 100%; " cellpadding="0" cellspacing="0" ><tbody><tr style="vertical-align: top"><td style=" word-break: break-word; border-collapse: collapse !important; vertical-align: top; " ><!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: {background_color};"><![endif]--><div class="u-row-container" style="padding: 0px; background-color: transparent" ><div class="u-row" style=" margin: 0 auto; min-width: 320px; max-width: 600px; overflow-wrap: break-word; word-wrap: break-word; word-break: break-word; background-color: {background_color}; " ><div style=" border-collapse: collapse; display: table; width: 100%; background-color: transparent; " ><!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: {background_color};"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style=" max-width: 320px; min-width: 600px; display: table-cell; vertical-align: top; " ><div style="width: 100% !important"><!--[if (!mso)&(!IE)]><!--><div style=" padding: 0px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-right: 0px solid transparent; border-bottom: 0px solid transparent; " ><!--<![endif]--><table style="font-family: arial, helvetica, sans-serif" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0" ><tbody><tr><td style=" overflow-wrap: break-word; word-break: break-word; padding: 10px; font-family: arial, helvetica, sans-serif; " align="left" >{shop_logo}<table style="font-family: arial, helvetica, sans-serif" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0" ><tbody><tr><td style=" overflow-wrap: break-word; word-break: break-word; padding: 10px; font-family: arial, helvetica, sans-serif; " align="left" ><div style=" line-height: 140%; text-align: left; word-wrap: break-word" > {top_text} </div></td></tr></tbody></table>{coupon_section}{button_content}<table style="font-family: arial, helvetica, sans-serif" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0" ><tbody><tr><td style=" overflow-wrap: break-word; word-break: break-word; padding: 10px; font-family: arial, helvetica, sans-serif; " align="left" ><div style=" line-height: 140%; text-align: left; word-wrap: break-word; " > {bottom_text} </div></td></tr></tbody></table>{powered_by}<!--[if (!mso)&(!IE)]><!--></div><!--<![endif]--></div></div><!--[if (mso)|(IE)]></td><![endif]--><!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><!--[if (mso)|(IE)]></td></tr></table><![endif]--></td></tr></tbody></table><!--[if mso]></div><![endif]--><!--[if IE]></div><![endif]--></body></html>',
  shopLogo:
    '<table width="100%" cellpadding="0" cellspacing="0" border="0" ><tr style="border-bottom: 1px solid #cbcbcb"><td style=" padding: 12px 0" align="center" ><img align="center" border="0" src="{shop_logo_src}" alt="Shop logo" title="Shop logo" style="max-height: 180px; width:auto; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; clear: both; display: inline-block !important; border: none; float: none; max-width:100%" /></td></tr></table></td></tr></tbody></table>',
  button:
    '<tr><td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left"><div align="center"><!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:arial,helvetica,sans-serif;"><tr><td style="font-family:arial,helvetica,sans-serif;" align="center"><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="{review_request_link}" style="height:46px; v-text-anchor:middle; width:522px;" arcsize="35%" stroke="f" fillcolor="{button_color}"><w:anchorlock/><center style="color:#FFFFFF;font-family:arial,helvetica,sans-serif;"><![endif]--><a href="{button_link}" target="_self" style="box-sizing: border-box;display: inline-block;font-family:arial,helvetica,sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #FFFFFF; background-color:{button_color}; border-radius: 16px; -webkit-border-radius: 16px; -moz-border-radius: 16px; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;"><span style="display:block;padding:10px 20px 10px 20px;line-height:120%;"><span style="font-size: 22px; line-height: 26px;">{button_text}</span></span></a><!--[if mso]></center></v:roundrect></td></tr></table><![endif]--></div></td></tr>',
  starRow:
    ' <table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tr><td style="overflow-wrap: break-word; word-break: break-word; padding: 5px; font-family: arial, helvetica, sans-serif;" align="left"><div align="center"><!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:arial,helvetica,sans-serif;"><tr><td style="font-family:arial,helvetica,sans-serif;" align="center"><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="{star_link}" style="height:37px; v-text-anchor:middle; width:139px;" arcsize="11%" stroke="f" ><w:anchorlock/><center style="color:#FFFFFF;font-family:arial,helvetica,sans-serif;"><![endif]-->{star_pics}<!--[if mso]></center></v:roundrect></td></tr></table><![endif]--></div></td></tr></table>',
  starPic:
    '<a href="{star_link}" target="_blank" style="padding: 2px; box-sizing: border-box; display: inline-block; font-family: arial, helvetica, sans-serif; text-decoration: none; -webkit-text-size-adjust: none; text-align: center;  overflow-wrap: break-word; word-break: break-word; word-wrap: break-word; mso-border-alt: none;" ><span style="color:{button_color}; font-size:24px">&#9733;</span></a>',
  productImage:
    '<table style="font-family: arial, helvetica, sans-serif" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody> <tr><td style="padding: 10px" align="center"> <a href="{review_request_link}" target="_blank" style="text-decoration:none;color:inherit;display: inline-block !important; max-width:100%"> <img align="center" border="0" src="{product_image_url}" alt="{product_name}" title="{product_name}" style="max-height: 360px; width:auto; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; clear: both; display: inline-block !important; border: none; float: none; max-width:100%"/> </a></td></tr></tbody></table>',
  productName:
    '<table style="font-family: arial, helvetica, sans-serif" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td><div style="text-align: center; text-transform: uppercase; line-height: 140%; font-weight: 400; font-size: 18px; word-wrap: break-word"><a href="{review_request_link}" target="_blank" style="text-decoration:none;color:inherit">{product_name}</a></div></td></tr></tbody></table>',
  htmlButton:
    '<table style="font-family: arial, helvetica, sans-serif" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody> {request_link} </tbody></table>',
  htmlText:
    '<p style="font-size: 18px; font-weight: 400; line-height: 140%; text-align: center; margin-bottom: 16px;">{content}</p>',
  divider:
    '<table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left"><table height="0px" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 1px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"><span>&#160;</span></td></tr></tbody></table></td></tr></tbody></table>',
  multipleProductsWrapper:
    '<table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"> <tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:20px 40px;" align="center"> <table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"> <tbody><tr> <td colspan="1" style="" align="center"> {multiple_products} </td></tr></tbody></table></td></tr></tbody></table>',
  multipleProducts:
    ' {product_image} {product_name_block} {small_stars} <div style="margin-top:8px; color:#646464; font-size:12px;">{product_text}</div>',
  couponWrapper:
    '<table style="font-family: arial, helvetica, sans-serif" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0" ><tbody><tr><td style=" overflow-wrap: break-word; word-break: break-word; padding: 10px; font-family: arial, helvetica, sans-serif; " align="left" ><div style=" line-height: 140%; text-align: center; word-wrap: break-word; border: 1px black dashed; background: #f8f8f8; padding: 16px 8px; font-size: 18px" > {coupon_text} </div></td></tr></tbody></table>',
  smallStars:
    '<div style="display:inline-block;font-family:arial,helvetica,sans-serif;text-decoration:none;text-align:left;width:auto;word-break:break-word;word-wrap:break-word; padding-top:24px"><a href="{review_request_link}&rating=1" target="_blank" style="text-decoration:none;color:{button_color};font-size:24px;font-weight:bold">☆</a><a href="{review_request_link}&rating=2" target="_blank" style="text-decoration:none;color:{button_color};font-size:24px;font-weight:bold">☆</a><a href="{review_request_link}&rating=3" target="_blank" style="text-decoration:none;color:{button_color};font-size:24px;font-weight:bold">☆</a><a href="{review_request_link}&rating=4" target="_blank" style="text-decoration:none;color:{button_color};font-size:24px;font-weight:bold">☆</a><a href="{review_request_link}&rating=5" target="_blank" style="text-decoration:none;color:{button_color};font-size:24px;font-weight:bold">☆</a></div>',
  poweredBy:
    '<table style="font-family: arial, helvetica, sans-serif" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0" ><tbody><tr style="border-top: 1px solid #cbcbcb""><td style=" overflow-wrap: break-word; word-break: break-word; padding: 16px 0; font-family: arial, helvetica, sans-serif; text-align: left; vertical-align: middle" align="left" valign="middle" width="85px"><span style="color:#525252; margin-right: 6px; font-size:14px">Powered by</span></td><td style=" overflow-wrap: break-word; word-break: break-word; padding: 16px 0; font-family: arial, helvetica, sans-serif; text-align: left; vertical-align: middle" align="left" valign="middle"><img style="margin: 0; border: 0; padding: 0; height: 22px;width: 73px;vertical-align: middle; display: block;" width="73" height="22" src="https://cdn.opinew.com/logos/Opinew_logo_full.png" alt=""></td><td style=" overflow-wrap: break-word; word-break: break-word; padding: 10px; font-family: arial, helvetica, sans-serif; text-align: right; vertical-align: middle" align="right" valign="middle" ><a style="color:#525252; text-decoration: none; font-size:14px" href="https://www.opinew.com">www.opinew.com</a></td></tr></tbody></table>',
};
export const OpinewConsts = CONSTS;
export const OpinewRoutes = Routes;

OpinewRoutes.install = function (Vue) {
  Vue.prototype.$getRoute = key => {
    return Routes[key];
  };
};

export const dashboardLanguages = [
  { name: CONFIG_CONSTS.ENGLISH, value: CONFIG_CONSTS.EN },
  { name: CONFIG_CONSTS.ESPANOL, value: CONFIG_CONSTS.ES },
  { name: CONFIG_CONSTS.FRANCAIS, value: CONFIG_CONSTS.FR },
  { name: 'Dansk', value: 'da' },
  { name: 'Deutsch', value: 'de' },
  { name: 'Čeština', value: 'cs' },
  { name: 'Italiano', value: 'it' },
  { name: '日本語', value: 'ja' },
  { name: '한국어', value: 'ko' },
  { name: 'Nederlands', value: 'nl' },
  { name: 'Norsk', value: 'no' },
  { name: 'Polski', value: 'pl' },
  { name: 'Português (Brasil)', value: 'pt_BR' },
  { name: 'Português (Portugal)', value: 'pt_PT' },
  { name: 'Suomi', value: 'fi' },
  { name: 'Svenska', value: 'sv' },
  { name: 'Türkçe', value: 'tr' },
  { name: '简体中文', value: 'zh_CN' },
  { name: '繁體中文', value: 'zh_TW' },
];

export default OpinewConsts;
